import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/view/index'
// import vital from '@/view/data/vital'
// import access from '@/view/data/access'
import autoload from '@/utils/autoload.js'

//解决路由重复问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
//文件命名不能重复
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: autoload.Index,
      children: [
        { path: '/showNoAuth', name: '无操作权限', component: autoload.ShowNoAuth },
        { path: '/vital', name: 'vital', component: autoload.Vital },
        { path: '/access', name: 'access', component: autoload.Access },
      ]
    },
    {
      path: '/magreement',
      name: 'magreement',
      component: autoload.Magreement,
    },
    {
      path: '/mprivacy',
      name: 'mprivacy',
      component: autoload.Mprivacy
    },
    {
      path: '/login',
      name: 'login',
      component: autoload.Login
    },
    {
      path: '/',
      name: '首页管理',
      component: autoload.Index,
      children: [
        {
          path: '/home', name: '首页', component: autoload.Home, meta: {
            name: '首页',
            pathName: ['首页管理', '首页']
          },
        },
      ]
    },
    {
      path: '/',
      name: '系统',
      component: autoload.Index,
      children: [
        {
          path: '/Adminindex', name: '网站管理员', component: autoload.Adminindex, meta: {
            name: '网站管理员',
            pathName: ['系统', '网站管理员']
          },
        },
        {
          path: '/AdminindexAdd', name: '添加管理员', component: autoload.AdminindexAdd, meta: {
            name: '添加管理员',
            pathName: ['系统', '添加管理员']
          },
        },
        {
          path: '/rolemanagement', name: '角色列表', component: autoload.Rolemanagement, meta: {
            name: '角色列表',
            pathName: ['系统', '角色列表']
          },
        },
        {
          path: '/roleAdd', name: '添加角色', component: autoload.RoleAdd, meta: {
            name: '添加角色',
            pathName: ['系统', '添加角色']
          },
        },
        {
          path: '/authorization', name: '角色授权', component: autoload.Authorization, meta: {
            name: '角色授权',
            pathName: ['系统', '角色授权']
          },
        },

      ]
    },
    {
      path: '/',
      name: '招聘管理',
      component: autoload.Index,
      children: [

        {
          path: '/oaadminEdit', name: '添加内部员工', component: autoload.OaadminEdit, meta: {
            name: '招聘管理',
            pathName: ['招聘管理', '添加内部员工']
          },
        },

        {
          path: '/oaresumelist', name: '求职者列表', component: autoload.Oaresumelist, meta: {
            name: '招聘管理',
            pathName: ['招聘管理', '求职者列表']
          },
        },
        {
          path: '/oaworkerlist', name: '员工列表', component: autoload.Oaworkerlist, meta: {
            name: '招聘管理',
            pathName: ['招聘管理', '员工列表']
          },
        },

        {
          path: '/oawaitinterviewlist', name: '待面试列表', component: autoload.Oawaitinterviewlist, meta: {
            name: '招聘管理',
            pathName: ['招聘管理', '待面试列表']
          },
        },
        {
          path: '/oawaitentrylist', name: '待入职列表', component: autoload.Oawaitentrylist, meta: {
            name: '招聘管理',
            pathName: ['招聘管理', '待入职列表']
          },
        },
        {
          path: '/oaleaveerlist', name: '离职列表', component: autoload.Oaleaveerlist, meta: {
            name: '招聘管理',
            pathName: ['招聘管理', '离职列表']
          },
        },
        {
          path: '/oapubliclist', name: '公共池列表', component: autoload.Oapubliclist, meta: {
            name: '招聘管理',
            pathName: ['招聘管理', '公共池列表']
          },
        },
        {
          path: '/oaalllist', name: '信息采集列表', component: autoload.Oaalllist, meta: {
            name: '招聘管理',
            pathName: ['招聘管理', '信息采集列表']
          },
        },
        {
          path: '/blacklist', name: '黑名单', component: autoload.Blacklist, meta: {
            name: '招聘管理',
            pathName: ['招聘管理', '黑名单']
          },
        },

      ]
    },
    {
         path: '/',
         name: '职位管理',
         component: autoload.Index,
         children: [
           {
             path: '/jobsList', name: '工厂职位列表', component: autoload.CompanyJobsList, meta: {
               name: '工厂职位列表',
               pathName: ['职位管理', '职位列表']
             },
           },
           {
             path: '/addJobs', name: '添加职位', component: autoload.AddCompanyJobs, meta: {
               name: '添加职位',
               pathName: ['职位管理', '添加职位']
             },
           },
           {
             path: '/oacompanylist', name: '工厂列表', component: autoload.Oacompanylist, meta: {
               name: '工厂列表',
               pathName: ['职位管理', '工厂列表']
             },
           },
           {
             path: '/oacompanyEdit', name: '添加工厂', component: autoload.OacompanyEdit, meta: {
               name: '添加工厂',
               pathName: ['职位管理', '添加工厂']
             },
           },

         ]
       },
       {
            path: '/',
            name: '公司架构',
            component: autoload.Index,
            children: [
              {
                path: '/enterpriseInfo', name: '公司信息', component: autoload.EnterpriseInfo, meta: {
                  name: '公司信息',
                  pathName: ['公司架构', '公司信息']
                },
              },
              {
                path: '/enterpriseDepartment', name: '公司部门', component: autoload.EnterpriseDepartment, meta: {
                  name: '公司部门',
                  pathName: ['公司架构', '公司部门']
                },
              },
              {
                path: '/addEnterpriseDepartment', name: '添加部门', component: autoload.AddEnterpriseDepartment, meta: {
                  name: '添加部门',
                  pathName: ['公司架构', '公司部门','添加部门']
                },
              },
              {
                path: '/enterprisePosition', name: '公司职位', component: autoload.EnterprisePosition, meta: {
                  name: '公司职位',
                  pathName: ['公司架构', '公司职位']
                },
              },
              {
                path: '/oasystemadminlist', name: '内部职工列表', component: autoload.Oasystemadminlist, meta: {
                  name: '内部职工列表',
                  pathName: ['公司架构', '内部职工列表']
                },
              },
              {
                path: '/miniAuthorization', name: '公司职位', component: autoload.MiniAuthorization, meta: {
                  name: '小程序授权',
                  pathName: ['公司架构', '公司职位','小程序授权']
                },
              },

            ]
          },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js